var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSi4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13",
    "data-name": "Group 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44.349,
    height: 47,
    viewBox: "0 0 44.349 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.489,
    y1: -0.224,
    x2: -0.429,
    y2: -0.224,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e72f70"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M333.461,136.817a11.382,11.382,0,0,0-9.771,5.729,31.91,31.91,0,0,0-3.6,8.948,39.889,39.889,0,0,0-1.1,9.369,36.582,36.582,0,0,0,2.559,13.823c1.831,4.392,4.566,7.651,7.946,8.752,3.9,1.27,9.925-.9,15.819-4.48,9.174-5.57,18.025-14.549,18.025-19.268a3.238,3.238,0,0,0-.044-.546.233.233,0,0,0,0-.025,16.118,16.118,0,0,0-2.425-5.711C355.576,145.13,343.118,136.417,333.461,136.817Z",
    transform: "translate(-318.989 -136.804)",
    fill: "url(#linear-gradient)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(10.397 13.712)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M359.238,169.192a5.2,5.2,0,0,0-1.579-3.335,5.416,5.416,0,0,0-3.582-1.453,70.7,70.7,0,0,0-9.661.108,4.925,4.925,0,0,0-4.224,3.794c-.466,1.66-.374,9.321-.1,10.962a4.943,4.943,0,0,0,3.925,4.262c1.539.4,9.11.344,10.809.071a4.957,4.957,0,0,0,4.279-3.906c.447-1.7.289-8.963.134-10.5m-1.8,9.759a3.307,3.307,0,0,1-3.108,2.95c-1.573.173-8.611.267-10.071-.142A3.2,3.2,0,0,1,341.828,179a65.9,65.9,0,0,1,0-9.854,3.306,3.306,0,0,1,3.1-2.94,68.847,68.847,0,0,1,9.615.04,3.3,3.3,0,0,1,2.941,3.112,69.428,69.428,0,0,1-.039,9.592m-7.806-9.9a5.007,5.007,0,1,0,5.007,5.013,5,5,0,0,0-5.007-5.013m-.035,8.245a3.239,3.239,0,1,1,3.275-3.227,3.235,3.235,0,0,1-3.275,3.227M356,168.859a1.172,1.172,0,1,1-1.16-1.18,1.162,1.162,0,0,1,1.16,1.18",
    transform: "translate(-339.865 -164.294)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSi4);
export default __webpack_public_path__ + "static/media/si4.bcc8fe6c5c8b43c89f0e166c21136fd2.svg";
export { ForwardRef as ReactComponent };